import { Link } from "react-router-dom";
import { cuartosFriosHeroImage } from "@/mocks/serviceCuartosFriosData";

export default function CuartosFriosHero() {
  return (
    <section className="relative min-h-[460px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={cuartosFriosHeroImage}
          alt="Cuarto frío industrial moderno con paneles aislantes, iluminación profesional y sistema de refrigeración"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay-gradient absolute inset-0" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/20" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-background-400 mb-6">
            <Link
              to="/"
              className="hover:text-background-200 transition-colors whitespace-nowrap"
            >
              Inicio
            </Link>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-500" />
            <span className="text-background-200 whitespace-nowrap">Servicios</span>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-500" />
            <span className="text-background-200 whitespace-nowrap">Cuartos Fríos</span>
          </nav>

          <h1
            className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4"
            style={{ textShadow: "0 2px 16px rgba(0,0,0,0.85), 0 1px 3px rgba(0,0,0,0.9)" }}
          >
            CUARTOS FRÍOS
          </h1>

          <p
            className="text-base md:text-lg text-white font-semibold mb-4 leading-relaxed"
            style={{ textShadow: "0 1px 8px rgba(0,0,0,0.85)" }}
          >
            Soluciones de refrigeración para conservación y congelación
          </p>

          <p
            className="text-background-100 text-sm md:text-base max-w-2xl leading-relaxed mb-8"
            style={{ textShadow: "0 1px 6px rgba(0,0,0,0.8)" }}
          >
            Diseñamos, instalamos y realizamos mantenimiento de cuartos fríos adaptados a las
            necesidades de cada operación, garantizando condiciones controladas de temperatura para la
            conservación y protección de diferentes productos.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#cotizacion"
              className="px-7 py-3.5 rounded-lg bg-[#0087a4] text-white font-semibold text-sm md:text-base hover:bg-[#006f86] transition-colors shadow-lg shadow-[#0087a4]/20 text-center whitespace-nowrap"
            >
              <i className="ri-file-list-3-line mr-2" />
              SOLICITAR COTIZACIÓN
            </a>
            <a
              href="https://wa.me/573232209100"
              target="_blank"
              rel="noopener noreferrer"
              className="px-7 py-3.5 rounded-lg bg-white/10 text-background-50 font-semibold text-sm md:text-base border border-white/20 hover:bg-white/20 transition-colors text-center whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2" />
              CONTACTAR A SERIN
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}